import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TokenManager from '../../../utils/storage/TokenManager';
import { AIChatAgentIcons } from '../../helpers/iconHelpers';
import './AIChatAgent.sass';

const { AIIcon, HeaderIcon } = AIChatAgentIcons;

const AI_STAGE_URL = 'https://ai-stage.roscolive.com/';
const AI_PROD_URL = 'https://ai.roscolive.com/';
const PROD_HOSTNAME = 'fleet.roscolive.com';

const getAIChatAgentUrl = () => (
	location.hostname === PROD_HOSTNAME ? AI_PROD_URL : AI_STAGE_URL
);

const AIChatAgent = () => {
	const { t } = useTranslation('translation', { keyPrefix: 'aiChatAgent' });

	const [isOpen, setIsOpen] = useState(false);
	const [frameSrc, setFrameSrc] = useState('');

	useEffect(() => {
		if (!isOpen || frameSrc) return;

		TokenManager.getSessionToken().then((token) => {
			setFrameSrc(`${getAIChatAgentUrl()}#session_token=${encodeURIComponent(token || '')}`);
		});
	}, [isOpen, frameSrc]);

	return (
		<div className="ai-chat-agent">
			{isOpen && (
				<div className="popup">
					<div className="main">
						<div className="header">
							<div className="header-left">
								<div className="header-icon-wrap"><HeaderIcon className="header-icon" /></div>
								<div className="header-info">
									<span className="header-title">{t('headerTitle')}</span>
								</div>
							</div>
							<button className="close" onClick={() => setIsOpen(false)} aria-label="Close">&#x2715;</button>
						</div>

						{frameSrc && (
							<div className="ai-frame-wrap">
								<iframe src={frameSrc} title={t('headerTitle')} />
							</div>
						)}
					</div>
				</div>
			)}

			<div className="border-wrap" onClick={() => setIsOpen(o => !o)}>
				<button className="btn">
					<AIIcon />
					<span className="label">{t('label')}</span>
				</button>
			</div>
		</div>
	);
};

export default AIChatAgent;
